import { el, clear, formatarNome, norm } from '../lib/dom.js';
import { abrirModal } from './modal.js';
import { toast } from '../lib/toast.js';
import { listarOperadores, verificarPin, definirOperador, operadorAtual } from '../lib/operador.js';
import { sessao } from '../lib/auth.js';
import { mostrarFeedbacksRecusa } from './feedbackRecusa.js';

/** Modal de troca rápida de operador: busca + cartões (toque no nome) + PIN com auto-entrar. */
function legendaAcessos() {
  const item = (cls, txt) => el('span', {}, [el('i', { class: 'op-dot ' + cls }), ' ' + txt]);
  return el('div', { class: 'op-legenda' }, [
    item('op-dot--gestor', 'Gestor'),
    item('op-dot--supervisor', 'Supervisor'),
    item('op-dot--recep_adm', 'Recepção adm.'),
    item('op-dot--recep_assist', 'Recepção assist.'),
  ]);
}

export function abrirTrocaOperador(aoTrocar) {
  let escolhido = null;
  let verificando = false;
  let timer = null;
  let todos = [];

  const busca = el('input', { type: 'text', class: 'op-busca', placeholder: 'Buscar pelo nome…', autocomplete: 'off' });
  const lista = el('div', { class: 'op-lista' }, [el('span', { class: 'view__sub', text: 'Carregando…' })]);
  const selNome = el('div', { class: 'op-sel-nome' });
  const pin = el('input', { type: 'password', inputmode: 'numeric', maxlength: '6', class: 'op-pin', placeholder: '••••' });
  const erroEl = el('div', { class: 'op-erro', style: 'display:none', text: 'PIN incorreto' });
  const pinWrap = el('div', { class: 'op-pin-wrap', style: 'display:none' }, [selNome, pin, erroEl]);

  function limparErro() { erroEl.style.display = 'none'; pin.classList.remove('op-pin--erro'); }
  function mostrarErro(precisaTrocar) {
    erroEl.textContent = precisaTrocar ? 'Muitos erros. Peça ao gestor para redefinir seu PIN.' : 'PIN incorreto';
    erroEl.style.display = '';
    pin.classList.remove('op-pin--erro'); void pin.offsetWidth; pin.classList.add('op-pin--erro');
    pin.value = ''; pin.focus();
  }

  function selecionar(o, card) {
    escolhido = o;
    [...lista.children].forEach((c) => c.classList && c.classList.remove('op-item--sel'));
    card.classList.add('op-item--sel');
    selNome.textContent = `PIN de ${formatarNome(o.nome)}`;
    pinWrap.style.display = ''; pin.value = ''; limparErro(); pin.focus();
  }

  function pintar(filtro) {
    clear(lista);
    const t = norm(filtro || '');
    const filtrados = t ? todos.filter((o) => norm(o.nome).includes(t)) : todos;
    const ORDEM = { RECEP_ASSIST: 0, RECEP_ADM: 1, SUPERVISOR: 2, GESTOR: 3 };
    const arr = [...filtrados].sort((a, b) => {
      const ra = ORDEM[a.perfil] ?? 9, rb = ORDEM[b.perfil] ?? 9;
      return ra !== rb ? ra - rb : norm(a.nome).localeCompare(norm(b.nome));
    });
    if (!arr.length) { lista.append(el('span', { class: 'view__sub', text: 'Ninguém encontrado.' })); return; }
    arr.forEach((o) => {
      const nome = formatarNome(o.nome);
      const card = el('button', { type: 'button', class: 'op-item', title: nome }, [
        el('span', { class: 'op-item__av op-item__av--' + String(o.perfil || '').toLowerCase(), text: (nome[0] || '?').toUpperCase() }),
        el('div', { class: 'op-item__txt' }, [
          el('span', { class: 'op-item__nome', text: nome }),
          o.empresa ? el('span', { class: 'op-item__emp', text: o.empresa, title: o.empresa }) : null,
        ]),
      ]);
      card.addEventListener('click', () => selecionar(o, card));
      lista.append(card);
    });
  }

  listarOperadores().then((ops) => {
    todos = ops.filter((o) => o.id !== operadorAtual.id && o.id !== (sessao.usuario?.id ?? null));
    if (!todos.length) { clear(lista); lista.append(el('span', { class: 'view__sub', text: 'Nenhum outro operador cadastrado.' })); return; }
    pintar('');
  });

  busca.addEventListener('input', () => pintar(busca.value));

  function entrarComOperador() {
    definirOperador({ id: escolhido.id, nome: formatarNome(escolhido.nome), perfil: escolhido.perfil, permissoes: escolhido.permissoes });
    toast(`Operador: ${formatarNome(escolhido.nome)}`, 'sucesso');
    aoTrocar?.();
    mostrarFeedbacksRecusa();
  }

  async function confirmar() {
    if (!escolhido) { toast('Toque no seu nome.', 'erro'); return false; }
    const v = pin.value.trim();
    if (!v) { toast('Digite seu PIN.', 'erro'); return false; }
    const r = await verificarPin(escolhido.id, v);
    if (!r.ok) { mostrarErro(r.precisaTrocar); return false; }
    entrarComOperador();
    return true;
  }

  const modalRef = abrirModal({
    titulo: 'Trocar operador', classe: 'modal--larga',
    corpo: [el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Toque no seu nome e digite seu PIN.' }), busca, legendaAcessos(), lista, pinWrap],
    acoes: [
      { rotulo: 'Cancelar', classe: 'btn' },
      { rotulo: 'Confirmar', classe: 'btn btn--primario', onClick: confirmar },
    ],
  });

  // Auto-entrar: ao digitar o PIN (4+), verifica; certo -> entra; errado (após parar) -> mostra erro.
  pin.addEventListener('input', () => {
    const v = pin.value.trim();
    clearTimeout(timer); limparErro();
    if (!escolhido || v.length < 4 || verificando) return;
    timer = setTimeout(async () => {
      verificando = true;
      const r = await verificarPin(escolhido.id, v);
      verificando = false;
      if (pin.value.trim() !== v) return;
      if (r.ok) { entrarComOperador(); modalRef.fechar(); }
      else { mostrarErro(r.precisaTrocar); }
    }, 320);
  });
}